export interface FilterItem {
  key: string,
  label: string,
  count: number,
  active: boolean,
  type: FilterType
}

export enum FilterType {
  Status = "Status",
  DateRange = "Date range",
  Mode = "Mode",
  RiskLevel = "Risk level",
  AtRisk = "At Risk"
}

export interface FilterOption {
  key: string,
  label: string,
  active: boolean
}

export enum statusFilterEnum {
  Booked = "Booked",
  Incomplete = "Incomplete",
  InTransit = "In Transit",
  Delivered = "Delivered",
  Ordered = "Ordered"
}

export enum modeFilterEnum {
  Truckload = "Truckload",
  Intermodal = "Intermodal",
  LTL = "LTL",
  Flatbed = "Flatbed",
  Air = "Air",
  Consolidated = "Consolidated",
  Bulk = "Bulk",
  Ocean = "Ocean",
  Rail = "Rail",
  Small_Parcel = "Small Parcel"
}

export enum dateRangesEnum {
  New = "New",
  Requested_Pickup_Today = "Requested Pickup Today",
  Requested_Pickup_This_Week = "Requested Pickup This Week",
  Requested_Delivery_Today = "Requested Delivery Today",
  Requested_Delivery_This_Week = "Requested Delivery This Week",
}

export enum riskLevelEnum {
  Early = "Early",
  On_Time = "On Time",
  At_Risk = "At Risk",
  Late = "Late"
}

export const statusFilterSet: FilterOption[] = [
  {
    key: statusFilterEnum.Booked,
    label: "Booked",
    active: false,
  },
  {
    key: statusFilterEnum.Incomplete,
    label: "Incomplete",
    active: false,
  },
  {
    key: statusFilterEnum.InTransit,
    label: "In-transit",
    active: false
  },
  {
    key: statusFilterEnum.Delivered,
    label: "Delivered",
    active: false
  },
  {
    key: statusFilterEnum.Ordered,
    label: "Ordered",
    active: false
  }
];

export const modeFilterSet: FilterOption[] = [
  {
    key: modeFilterEnum.Truckload,
    label: "Truckload",
    active: false
  },
  {
    key: modeFilterEnum.Intermodal,
    label: "Intermodal",
    active: false
  },
  {
    key: modeFilterEnum.LTL,
    label: "LTL",
    active: false
  },
  {
    key: modeFilterEnum.Flatbed,
    label: "Flatbed",
    active: false
  },
  {
    key: modeFilterEnum.Air,
    label: "Air",
    active: false
  },
  {
    key: modeFilterEnum.Consolidated,
    label: "Consolidated",
    active: false
  },
  {
    key: modeFilterEnum.Bulk,
    label: "Bulk",
    active: false
  },
  {
    key: modeFilterEnum.Ocean,
    label: "Ocean",
    active: false
  },
  {
    key: modeFilterEnum.Rail,
    label: "Rail",
    active: false
  },
  {
    key: modeFilterEnum.Small_Parcel,
    label: "Small Parcel",
    active: false
  }
];

export const dateRangesFilterSet: FilterOption[] = [
  {
    key: dateRangesEnum.New,
    label: "New",
    active: false
  },
  {
    key: dateRangesEnum.Requested_Pickup_Today,
    label: "Requested Pickup Today",
    active: false
  },
  {
    key: dateRangesEnum.Requested_Pickup_This_Week,
    label: "Requested Pickup This Week",
    active: false
  },
  {
    key: dateRangesEnum.Requested_Delivery_Today,
    label: "Requested Delivery Today",
    active: false
  },
  {
    key: dateRangesEnum.Requested_Delivery_This_Week,
    label: "Requested Delivery This Week",
    active: false
  }
]

export const riskLevelFilterSet: FilterOption[] = [
  {
    key: riskLevelEnum.Early,
    label: "Early",
    active: false
  },
  {
    key: riskLevelEnum.On_Time,
    label: "On-time",
    active: false
  },
  {
    key: riskLevelEnum.At_Risk,
    label: "At risk",
    active: false
  },
  {
    key: riskLevelEnum.Late,
    label: "Late",
    active: false
  }
]
